module.exports = __webpack_public_path__ + "img/wa.7e3273f4.png";